const track = (...args) => {
	if (!window.gtag) {
		return;
	}

	window.gtag(...args);
};

export const pageview = (props) => {
	track('config', process.env.REACT_APP_GA_MEASUREMENT_ID, props);
};

export const event = (type, props) => {
	track('event', type, props);
};
